"use strict";

module.exports = function () {
  return this.data;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/table-data.js
// module id = gm4B
// module chunks = 0